import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
//import '../../css/resultTable.css';
import Transcription from "./Transcription";
import '../../css/tabulky.css';

const styles = () => {
    return ({
        root: {
            width: '90%',
        },
        //paper: {
            marginTop: 1,
           // width: '90%',
            // overflowX: 'auto',
           // marginBottom: 1,
       // },
        table: {
            width: '100%',
        },
    });
};
const styl = () => {
    return ({
        even: {
            backgroundColor: '#f0f0f7',
            zIndex: 4,
        },
        odd: {
            backgroundColor: '#fafafa',
            zIndex: 4,
        },
        active: {
            backgroundColor: '#fbfbfb',
            zIndex: 4,
        }
    })
};

class WinklTable extends React.Component {
    render() {
        const styly = styl();
      //  const classes = styles();
      //   const columnSmall = {
      //       maxWidth: "10%"
      //   };
      //   const columnName = {
      //       maxWidth: "30%"
      //   };
      //   let old =  <div className={classes.root}>
      //       <Paper>
      //           <Table size="small">
      //               <TableHead>
      //                   <TableRow>
      //                       <TableCell><strong>Poř.<br/>čas 1</strong></TableCell>
      //                       <TableCell><strong>stč.<br/>spd 1</strong></TableCell>
      //                       <TableCell><strong>Jméno<br/>čas 2</strong></TableCell>
      //                       <TableCell><strong>čas<br/>spd 2</strong></TableCell>
      //                       <TableCell><strong>Stroj<br/>čas 3</strong></TableCell>
      //                       <TableCell><strong> <br/>spd 3</strong></TableCell>
      //                       <TableCell><strong> <br/>čas 4</strong></TableCell>
      //                       <TableCell><strong> <br/>spd 4</strong></TableCell>
      //                       <TableCell><strong>Kat.<br/>čas 5</strong></TableCell>
      //                       <TableCell><strong>objem<br/>spd 5</strong></TableCell>
      //                   </TableRow>
      //
      //               </TableHead>
      //               <TableBody>
      //
      //                   {this.props.athletes.map((athlet, key) => (
      //
      //                       <TableRow key={athlet.id} className={
      //                           this.props.raceInfo.stc === athlet.stc ? "resultRowActive" : (key % 2 === 0) ? "resultDark" : ''}>
      //                           <TableCell
      //                               style={columnSmall}>{athlet.poradi}.<br/>{Transcription.transposeTime(athlet.cas1, this.props.raceInfo.pocDes)}</TableCell>
      //                           <TableCell
      //                               style={columnSmall}><strong>{athlet.bib}</strong><br/>{Transcription.transposeSpd(athlet.speed1)}
      //                           </TableCell>
      //                           <TableCell style={columnName}>{athlet.jmeno}<br/>{Transcription.transposeTime(athlet.cas2, this.props.raceInfo.pocDes)}
      //                           </TableCell>
      //                           <TableCell align="right"
      //                                      style={columnSmall}><strong>{Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes)}</strong><br/>{Transcription.transposeSpd(athlet.speed2)}
      //                           </TableCell>
      //                           <TableCell style={columnName}>{athlet.klub}<br/>{Transcription.transposeTime(athlet.cas3, this.props.raceInfo.pocDes)}
      //                           </TableCell>
      //                           <TableCell style={columnSmall} align="right"><br/>{Transcription.transposeSpd(athlet.speed3)}
      //                           </TableCell>
      //                           <TableCell style={columnSmall} align="right"><br/>{Transcription.transposeTime(athlet.cas4, this.props.raceInfo.pocDes)}</TableCell>
      //                           <TableCell style={columnSmall} align="right"><br/>{Transcription.transposeSpd(athlet.speed4)}
      //                           </TableCell>
      //                           <TableCell style={columnSmall} align="right">{athlet.zkrkat}<br/>{Transcription.transposeTime(athlet.cas5, this.props.raceInfo.pocDes)}
      //                           </TableCell>
      //                           <TableCell style={columnSmall}
      //                                      align="right">{athlet.tj}<br/>{Transcription.transposeSpd(athlet.speed5)}
      //                           </TableCell>
      //                       </TableRow>
      //                   ))}
      //               </TableBody>
      //           </Table>
      //       </Paper>
      //   </div>;
        return (
            // <div className={"body2"}>
                <div className={"card"}>
                    <div className={"cardContent"}>
                        <table id={"druha"}>
                            <tbody>
                            <tr>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Poř.</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Stč</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Jméno</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700', textAlign:"right"}}>Čas</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700', textAlign:"center"}}>Stroj</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700', textAlign:"right"}}>Čas 1</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700', textAlign:"right"}}>Čas 2</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700', textAlign:"right"}}>Čas 3</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700', textAlign:"right"}}>Čas 4</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700', textAlign:"right"}}>Čas 5</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Objem</td>
                                <td style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Kat.</td>
                            </tr>
                            {this.props.athletes.map((athlet, key) => (
                                <tr key={athlet.id}>
                                    <td style={{backgroundColor: this.props.raceInfo.stc === athlet.stc ? '#0096ff' : key % 2===1 ? '#f0f0f7' : '#fafafa' }}>{athlet.poradi}.</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa' }}>{athlet.bib}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"left" }}>{athlet.jmeno}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"right" }}>{Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes)}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"left" }}>{athlet.klub}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"right" }}>{Transcription.transposeTime(athlet.cas1, this.props.raceInfo.pocDes)}<br/>{Transcription.transposeSpd(athlet.speed1)}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"right" }}>{Transcription.transposeTime(athlet.cas2, this.props.raceInfo.pocDes)}<br/>{Transcription.transposeSpd(athlet.speed2)}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"right" }}>{Transcription.transposeTime(athlet.cas3, this.props.raceInfo.pocDes)}<br/>{Transcription.transposeSpd(athlet.speed3)}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"right" }}>{Transcription.transposeTime(athlet.cas4, this.props.raceInfo.pocDes)}<br/>{Transcription.transposeSpd(athlet.speed4)}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa', textAlign:"right" }}>{Transcription.transposeTime(athlet.cas5, this.props.raceInfo.pocDes)}<br/>{Transcription.transposeSpd(athlet.speed5)}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa' }}>{athlet.tj}</td>
                                    <td style={{backgroundColor: key % 2===1 ? '#f0f0f7' : '#fafafa' }}>{athlet.zkrkat}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            // </div>
        )
    }

}

export default WinklTable;